// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"265":"Index","450":"About","810":"NotFound","982":"Price"}[chunkId] || chunkId) + "." + {"135":"49a5766a","265":"7e2ee6a9","295":"9c2664a2","450":"a60495c9","506":"3bba4481","709":"1f824c58","805":"8264bc3f","810":"cf7cb3be","982":"5df5112c"}[chunkId] + ".chunk.js";
};